import { createAmountInputCodec } from '../amount/amount-input.js';
import { formatFiatUnits } from '../amount/format-money.js';
import { fundingSettlementValue } from '../amount/fx.js';
import { fundingOperationAmounts } from './operation-presentation.js';
/** Historical receipts use their recorded valuation, never today's portfolio currency or FX. */
export function fundingReceivedPresentation(operation, locale, quoted) {
    if (operation.purpose === 'direct_token_purchase' && operation.purchase) {
        const delivery = operation.walletDelivery;
        const confirmed = (delivery?.state === 'confirmed' || delivery?.state === 'sandbox_confirmed') &&
            delivery.mint === operation.purchase.mint;
        const units = confirmed
            ? delivery.receivedUnits
            : 'quotedAmounts' in operation
                ? operation.quotedAmounts?.receivedUnits
                : undefined;
        return {
            value: units
                ? `${createAmountInputCodec(locale, operation.purchase.decimals).format(BigInt(units))} ${operation.purchase.title}`
                : null,
            estimated: !confirmed,
        };
    }
    if (operation.destinationAsset !== 'USDC_SOL')
        return { value: null, estimated: false };
    const receivedD6 = fundingOperationAmounts(operation, quoted).receivedD6;
    if (receivedD6 === null)
        return { value: null, estimated: false };
    const actual = operation.walletDelivery?.receivedUnits ?? operation.receivedD6;
    if ('exchangeSource' in operation ||
        'cryptoDepositSource' in operation ||
        'connectedWalletSource' in operation ||
        !operation.receiveTarget)
        return {
            value: `${createAmountInputCodec(locale, 6).format(BigInt(receivedD6))} USDC`,
            estimated: actual === null || actual === undefined,
        };
    const localUnits = fundingSettlementValue(receivedD6, operation.fiatCurrency, operation.fiatDecimals, operation.receiveTarget.fx);
    return {
        value: formatFiatUnits(localUnits, operation.fiatDecimals, operation.fiatCurrency, locale),
        estimated: actual === null || actual === undefined,
    };
}
